import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

const regionDecorator = (code, name) => {
  // Region PUS3 should appear as just another US environment on the frontend
  if (code === 'pus3') {
    return { code: 'us', name: 'US East' };
  }

  if (code === 'stage') {
    return { code: 'us', name: 'Stage' };
  }

  return { code, name };
};

const TenantDescription = ({ regionCode, regionName, subscription }) => {
  const region = regionDecorator(regionCode, regionName);

  return (
    <React.Fragment>
      <i
        className={styles.regionFlag}
        style={{
          background: `url("https://cdn.auth0.com/manhattan/versions/1.2247.0/assets/${region.code}.svg") no-repeat`
        }}
      />
      <span className={styles.regionName}>
        {region.name}
      </span>
      {subscription && <span className={styles.subscriptionName}>
        {` - ${subscription.name}`}
      </span>}
    </React.Fragment>
  );
};

TenantDescription.propTypes = {
  regionCode: PropTypes.string.isRequired,
  regionName: PropTypes.string.isRequired,
  subscription: PropTypes.object
};

export default TenantDescription;
